<div class="wrapper">
  <div class="heading text-type-15">RECENT REPORTS</div>
  <div class="list-section flex flex-wrap">
    @for (item of summary; track item; let isLast = $last) {
      <div
        class="text-type-11"
        [classList]="item.type"
        (click)="handleClick(item.type)"
        >
        {{ item.count }} {{ item.label }}
      </div>
      @if (!isLast) {
        <div
          class="divider"
        ></div>
      }
    }
  </div>
</div>
